var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelSms = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9.49 4a5.46 5.46 0 0 1 4.902 3.058c-3.994.063-6.986 3.768-6.153 7.715a5.4 5.4 0 0 1-1.083-.38l-2.597.514a.468.468 0 0 1-.55-.55l.513-2.566A5.4 5.4 0 0 1 4 9.458C4 6.448 6.463 4 9.49 4M19.68 15.206a5 5 0 0 1-.234.577l.513 2.566a.468.468 0 0 1-.459.56h-.012c-.038.002-.076-.009-2.676-.523a5.4 5.4 0 0 1-2.326.522 5.464 5.464 0 0 1-5.45-5.458 5.463 5.463 0 0 1 5.712-5.452c3.627.176 6.083 3.78 4.915 7.208z",
  clipRule: "evenodd"
})));
export default SvgGemChannelSms;